import React, { useMemo, useState,useRef,useEffect } from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  ListGroup,
  ListGroupItem,
  Nav, NavItem, NavLink, TabContent, TabPane, FormGroup, Label, Input , Row,
  Col,Card,
  Spinner,
} from "reactstrap";
import { useHistory,Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import Swal from "sweetalert2";
import * as Yup from "yup";
import "../../assets/scss/mobile/styleMobile.scss";
import { getSessionDataOnlyRead } from "utils/common";
import { Formik, Form,Field,ErrorMessage } from "formik";
import { getBankDetails,showMessage,withdrawFund,deleteUserBank} from "store/reducers/common.slice";
export default function Withdrawal() {
  const initialWithdrawValues = {
    bankId: "",
    upiId:"",
    amount: "",
    beneficiaryName: "",
    bankName: "",
    ifscCode: "",
    accountNumber: "",
    amount: "",
  };
  const validationWithdrawSchema = Yup.object().shape({
      upiId: Yup.string()
        .matches(/^[\w.-]+@[\w]+$/, "Enter a valid UPI ID")
        .required("UPI ID is required"),
      beneficiaryName: Yup.string().required("Beneficiary Name is required"),
      bankName: Yup.string().required("Bank Name is required"),
      ifscCode: Yup.string()
        .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Enter a valid IFSC Code")
        .required("IFSC Code is required"),
      accountNumber: Yup.string().required("Account Number is required"),
      amount: Yup.number()
        .positive("Amount must be positive")
        .required("Amount is required"),
  });
  const history = useHistory();
  const dispatch = useDispatch();
  const formRef = useRef(null);
  const location = useLocation(); 
  const [activeTab, setActiveTab] = useState(() => {
      return location.state?.activeTab || "1";
  });
  const { bankDetails,iswithdrawFund,withdrawFundLoading,isBankUpdated,userBankLoading} = useSelector(
    ({ common }) => common
  );
  useEffect(() => {
    dispatch(getBankDetails());
  }, [dispatch, isBankUpdated]);
  useEffect(() => {
    if (iswithdrawFund) {
      if (formRef && formRef.current) {
          formRef.current.resetForm();
      }
    }
  }, [iswithdrawFund]);
  const handleEdit = (bank) => {
    history.push("/app/add-edit-bank", { bankData: bank });
  };
  const handleDelete = (bankId) => {
      Swal.fire({
          title: "Are you sure?",
          text: `Are you sure to execute this order by market?`,
          icon: "question",
          showCancelButton: true,
          width: 400,
          height: 400,
          confirmButtonColor: "#885b24",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, Execute it!",
      }).then((result) => {
        if (result.isConfirmed) {
            dispatch(deleteUserBank(bankId));
        }
      });
  };
  return (
    <main className="trade_page">
      <header>
        <div className="confirm_order_header">
          <div className="close_icon">
            <span
              className="material-symbols-outlined"
              onClick={() => history.push('/app/profile')}
            >
            keyboard_backspace
            </span>{" "}
            <span>Withdraw</span>
          </div>
        </div>
      </header>
    <div className="orderBook_tabs my-4">
    {withdrawFundLoading || userBankLoading &&
        <div className="spinner-box">
          <Spinner className="ml-2" color="primary" />
        </div>
      }
      <Nav
        tabs
        className="nav nav-pills mb-3"
        id="pills-tab"
        role="tablist"
        style={{top: "50px" }}
      >
        <NavItem className="nav-item" role="presentation">
          <NavLink
            className={`nav-link fw-bold ${activeTab === "1" ? "active" : ""}`}
            onClick={() => {
              setActiveTab("1");
              formRef.current.resetForm();
            }}
            style={{fontSize: "15px", height: "50px", display: "flex", alignItems: "center", justifyContent: "center", }}
          >
            BANK ACCOUNT
          </NavLink>
        </NavItem>
        <NavItem className="nav-item" role="presentation">
          <NavLink
            className={`nav-link fw-bold ${activeTab === "2" ? "active" : ""}`}
            onClick={() => {
              setActiveTab("2");
            }}
             style={{fontSize: "15px", height: "50px", display: "flex", alignItems: "center", justifyContent: "center", }}
          >
            ADD BANK ACCOUNT
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
           <Formik
              initialValues={initialWithdrawValues}
              validationSchema={validationWithdrawSchema}
              onSubmit={(values) => dispatch(withdrawFund(values))}
              innerRef={formRef}
            >
              {({ values, errors, touched, setFieldValue,}) => (
                <div className="card">
                  <div className="card-body">
                    <Form>
                      <Row>
                        <Col md={6}>
                          <FormGroup>
                            <Field as="select" name="bankId" className="form-control"
                              value={values.bankId}
                              onChange={(e) => {
                                const selectedId = e.target.value;
                                setFieldValue("bankId", selectedId);
                                const selectedBank = bankDetails.find(
                                  (b) => b.id.toString() === selectedId
                                );
                                const fields = {
                                      beneficiaryName: selectedBank?.bankHolderName || "",
                                      bankName: selectedBank?.bankName || "",
                                      ifscCode: selectedBank?.bankIFSC || "",
                                      accountNumber: selectedBank?.bankAccountNumber || "",
                                      upiId: selectedBank?.bankUPI || ""
                                };
                                Object.entries(fields).forEach(([key, value]) =>
                                  setFieldValue(key, value)
                                );
                              }}
                            >
                             <option value="">-- Select Bank --</option>
                             {bankDetails?.map((bank) => (
                                <option key={bank.id} value={bank.id}>
                                {bank.bankName}</option>
                              ))}
                            </Field>
                            <span className="text-error">
                              <ErrorMessage name="accountType" />
                            </span>
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup>
                            <Field as={Input} type="text" name="upiId" placeholder="Enter UPI ID" />
                            <span className="text-error"><ErrorMessage name="upiId" /></span>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <FormGroup>
                            <Field as={Input} type="text" name="beneficiaryName" placeholder="Enter Beneficiary Name" />
                            <span className="text-error"><ErrorMessage name="beneficiaryName" /></span>
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup>
                            <Field as={Input} type="text" name="bankName" placeholder="Enter Bank Name" />
                            <span className="text-error"><ErrorMessage name="bankName" /></span>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <FormGroup>
                            <Field as={Input} type="text" name="ifscCode" placeholder="Enter IFSC Code" />
                            <span className="text-error"><ErrorMessage name="ifscCode" /></span>
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup>
                            <Field as={Input} type="text" name="accountNumber" placeholder="Enter Account Number" />
                            <span className="text-error"><ErrorMessage name="accountNumber" /></span>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <FormGroup>
                            <Field as={Input} type="number" name="amount" placeholder="Enter Amount" />
                            <span className="text-error"><ErrorMessage name="amount" /></span>
                          </FormGroup>
                        </Col>
                      </Row>

                      <ModalFooter>
                        <Button type="submit" color="default" className="w-100 py-2 btn-icon btn-3 mt-0">Submit</Button>
                      </ModalFooter>
                    </Form>
                  </div>
                </div>
              )}
            </Formik>
        </TabPane>

       <TabPane tabId="2" style={{ fontSize: '12px', padding: '8px', paddingBottom: '70px' }}>
          {bankDetails.map((bank) => (
            <Card key={bank.id} className="p-3 mb-3 shadow-sm rounded border">
                <Row className="align-items-start justify-content-between">
                  <Col xs={6} md={6}>
                    <span>
                      Bank Name: <strong>{bank.bankName}</strong>
                    </span>
                  </Col>
                  <Col xs={6} md={6}>
                    <span>
                      IFSC: <strong>{bank.bankIFSC}</strong>
                    </span>
                  </Col>
                </Row>
                <Row className="align-items-start justify-content-between">
                  <Col xs={8} md={8}>
                    <span>
                      A/C Number: <strong>{bank.bankAccountNumber}</strong>
                    </span>
                    <br />
                    <span>
                      UPI: <strong>{bank.bankUPI}</strong>
                    </span>
                  </Col>
                  <Col xs={4} md={4}>
                    <span className="material-symbols-outlined" style={{cursor: 'pointer', color: 'white', backgroundColor: '#808080a8', borderRadius: '50%', padding: '6px', marginRight: '10px', boxShadow: '0 2px 5px rgba(0,0,0,0.2)', fontSize: '20px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => handleDelete(bank.id)} >
                      delete
                    </span>
                    <span className="material-symbols-outlined" style={{cursor: 'pointer', color: 'white', backgroundColor: '#808080a8', borderRadius: '50%', padding: '6px', marginRight: '10px', boxShadow: '0 2px 5px rgba(0,0,0,0.2)', fontSize: '20px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }} 
                    onClick={() => handleEdit(bank)} > edit </span>
                  </Col>
                </Row>
            </Card>
          ))}
          <div style={{position: 'fixed', bottom: '60px', left: '0', width: '100%', padding: '0 12px', zIndex: '1000', }}>
           <Link to="/app/add-edit-bank" className="text-decoration-none"><Button type="button" color="default" className="w-100 py-2 btn-icon btn-2 mt-0">Add Bank Account</Button> </Link>
          </div>  
        </TabPane>
      </TabContent>
    </div>

    </main>
  );
}
